import actionType from "./actionTypes";
import initialState from "./initialState";


const commonReducer = (state = initialState, action) => {
  switch (action.type) {

    
    case actionType.SESSION_EXPIRE_FALSE:
    return {
    ...state,
      sessionExpireStatus : false
      };
    case actionType.SESSION_EXPIRED:
    return {
    ...state,
    loginDetails: null,
    loginStatus:false,
    sessionExpireStatus : true

      };
          case actionType.VERIFY_REGISTER_SUCCESS:
          return {
          ...state,
          verifyRegisterStatus: true,
          message: action.message,
          };
          case actionType.VERIFY_REGISTER_FAILURE:
          return {
            ...state,
            verifyRegisterStatus: false,
             error:action.error,
             message: action.message,
 
          };

    

          case actionType.EMAIL_VALID_SUCCESS:
          return {
          ...state,
          emailValidStatus:true,
           };
          case actionType.EMAIL_VALID_FAILURE:
          return {
            ...state,
            emailValidStatus: false
          };

          case actionType.MOBILE_VALID_SUCCESS:
          return {
          ...state,
          mobileValidStatus:true,
           };
          case actionType.MOBILE_VALID_FAILURE:
          return {
            ...state,
            mobileValidStatus: false
          };

          case actionType.GET_NPI_DATA_SUCCESS:
          return {
          ...state,
          getNpiStatus:true,
          saveRegDataStatus : false,
          getNpiData:action.payload
          };
          case actionType.GET_NPI_DATA_FAILURE:
          return {
            ...state,
            saveRegDataStatus : false,
            getNpiStatus: false
          };


          case actionType.NEWPASS_SUCCESS:
          return {
          ...state,
          newPassStatus: true,
          newPassDetails:action.payload
          };
          case actionType.NEWPASS_FAILURE:
          return {
            ...state,
            newPassStatus: false
          };


        case actionType.RANDOMPASS_SUCCESS:
        return {
          ...state,
          randomPassStatus: true,
          randomPassDetails:action.payload
        };
        case actionType.RANDOMPASS_FAILURE:
        return {
          ...state,
          randomPassStatus: false
        };


        case actionType.PROFILE_SUCCESS:
        return {
          ...state,
          sessionExpireStatus:false,
          loginStatus: true,
          profileStatus: true,
          profileDetails:action.payload
        };
        case actionType.PROFILE_FAILURE:
        return {
          ...state,
          loginStatus:false,
          profileStatus: false
        };
        case actionType.EDITPROFILE_SUCCESS:
         return {
          ...state,
          editProfileStatus: true,
          editProfileDetails:action.payload
        };
        case actionType.EDITPROFILE_FAILURE:
        return {
          ...state,
          editProfileStatus: false
        };
        case actionType.LOGIN_SUCCESS:
        return {
          ...state,
          sessionExpireStatus:false,
          loginDetails:action.payload.access_token,
          };
        case actionType.LOGIN_FAILURE:
        return {
          ...state,
           loginStatus: false,
           error:action.error
        };
       case actionType.FORGOTPASSWORD_SUCCESS:
       return {
         ...state,
         newPassStatus:false,
         forgotPasswordStatus: true,
         forgotPasswordDetails:action.payload,
          message: action.message
        };
        case actionType.FORGOTPASSWORD_FAILURE:
        return {
          ...state,
          message: action.message,
          forgotPasswordStatus: false
        };
        case actionType.CHANGEPASSWORD_SUCCESS:
        return {
          ...state,
          changePasswordStatus: true,
          message: action.message
         };
         case actionType.CHANGEPASSWORD_FAILURE:
         return {
           ...state,
           message: action.message,
           changePasswordStatus: false
         };
         case  actionType.SHOW_IS_LOADING :
         return {
           ...state,
           isLoading: true
         };
       case actionType.HIDE_IS_LOADING :
         return {
           ...state,
           isLoading: false
         };
         case actionType.LOGOUT_USER:
         return {
           ...state,
           newPassStatus:false,
           changePasswordStatus:false,
           forgotPasswordStatus:false,
           loginDetails: null,
           loginStatus:false,
           profileDetails:null,
           profileStatus : false,
           message: null,
           isLoading: false,
           contactStatus:false,
         };
         case actionType.CONTACT_SUCCESS:
         return {
          ...state,
          contactStatus: true,
          message: action.message
         };
         case actionType.CONTACT_FAILURE:
         return {
          ...state,
          contactStatus: false,
          message: action.message
         };
         case actionType.VIEWREQUESTINFO_SUCCESS:
         return {
          ...state,
          finalCostStatus:false,
          fedexTrackingStatus:false,
          checkFaxstatus:false,
          viewRequestInfoStatus: true,
          message: action.message,
          viewRequestInfoDetails: action.payload,
         };
         case actionType.VIEWREQUESTINFO_FAILURE:
         return {
          ...state,
          viewRequestInfoStatus: false,
          message: action.message,
          
         };
         case actionType.VIEW_STATUS_CHANGE:
         return {
          ...state,
          viewRequestInfoStatus: false,

         };

         case actionType.REFRESH_ACCESS_TOKEN_SUCCESS:
         return {
          ...state,
          loginDetails:action.payload,


         };

         


    default:
      return state;
  }
};

 export default commonReducer;
// import actionType from "./actionTypes";
// import initialState from "./initialState";

// const commonReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case actionType.LOGIN_SUCCESS:
//       return {
//         ...state,
//         loginDetails: action.payload,
//         loginStatus: true,
//         message: action.message
//       };
//     case actionType.LOGIN_FAILURE:
//       return {
//         ...state,
//         message: action.error,
//         loginStatus: false
//       };